"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IInstallationDirectoryProvider = void 0;
/*---------------------------------------------------------------------------------------------
*  Licensed to the .NET Foundation under one or more agreements.
*  The .NET Foundation licenses this file to you under the MIT license.
*--------------------------------------------------------------------------------------------*/
const path = require("path");
class IInstallationDirectoryProvider {
    constructor(storagePath) {
        this.storagePath = storagePath;
    }
    getStoragePath() {
        const installFolderName = process.env._VSCODE_DOTNET_INSTALL_FOLDER || '.dotnet';
        return path.join(this.storagePath, installFolderName);
    }
}
exports.IInstallationDirectoryProvider = IInstallationDirectoryProvider;
//# sourceMappingURL=IInstallationDirectoryProvider.js.map